// extracted by mini-css-extract-plugin
export default {"myPage":"MyPage_myPage__oXgsW","myPageLower":"MyPage_myPageLower__1CwsO","tabMenu":"MyPage_tabMenu__4TdC0","tab":"MyPage_tab__KT3hQ","active":"MyPage_active__wpD5U"};